/*
 *
 * Headquarter constants
 *
 */

export const DEFAULT_ACTION = 'app/Headquarter/DEFAULT_ACTION';
